<app-navsec></app-navsec>
<div class="container mt-5">
  <br><br>
  <div class="col-lg-12">
    <div class="row">
      <div class="col-lg-6">
        <h4><img src="../../../assets/img/blog.png" width="50" class="img-fluid" alt="Responsive image"> Blog Torreón Market</h4>
      </div>
      <div class="col-lg-6">
        <form class="form-inline">
          <input class="form-control inp mt-2" [(ngModel)]="filterBlogTitle" name="filterBlogTitle" type="search" autocomplete="off" placeholder="Buscar post por titulo...">
          <button class="btnshc mt-2"><i class="fa fa-search"></i></button>
      </form>
      </div>
    </div>
  </div>
    <div class="col-12">
        <hr><br><br>
        <div class="row">
            <div class="col-lg-6 mb-3" *ngFor="let post of lista |fliterBlog: filterBlogTitle">
                <div class="card h-100" style="width: 100%;" (click)="verPost(post.id)">
                    <div class="row no-gutters">
                        <div class="col-md-4">
                            <img *ngIf="post.video == 'No'" [src]="post.imagen" class="card-img" alt="...">
                            <img *ngIf="post.video == 'Si'" src="../../../assets/img/FOTO-BLOG.png" class="card-img" alt="">
                        </div>
                        <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="card-title">{{post.titulo}}</h5>
                                <p class="card-text">{{post.introduccion}}</p>
                                <p class="card-text"><small class="text-muted">{{post.creado}}</small></p>
                            </div>
                            <div class="card-footer">
                              <div class="text-center">
                                <button class="btnPerBlog">VER MÁS</button>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<app-footer></app-footer>
